import { CustomAutocomplete } from "../../../../components/custom/CustomAutocomplete";
import { useGlobalMarketSpreadPriceContext } from "../../../../context/global-market/GlobalMarketSpreadPriceContext";
import { Box, Typography } from "@mui/material";
import LooksOne from "@mui/icons-material/LooksOne";
import { COLORS } from "../../../../ui/Theme";
import Grid2 from "@mui/material/Unstable_Grid2";

const SpreadPriceForm1 = () => {
  const {
    industries1,
    commodityTypes1,
    commodities1,
    transitTypes1,
    inputValues1,
    setInputValues1,
  } = useGlobalMarketSpreadPriceContext();

  const { industry, commodityType, commodity, transitType } = inputValues1;

  const clearForm = (field) => {
    switch (field) {
      case "industry":
        setInputValues1((prev) => ({
          ...prev,
          commodityType: null,
          commodity: null,
          transitType: null,
        }));
        break;
      case "commodityType":
        setInputValues1((prev) => ({
          ...prev,
          commodity: null,
          transitType: null,
        }));
        break;
      case "commodity":
        setInputValues1((prev) => ({
          ...prev,
          transitType: null,
        }));
        break;

      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 900,
          display: "flex",
          alignItems: "center",
          justifyContent: { xs: "center", md: "flex-start" },
          gap: 0.5,
        }}
      >
        کالا
        <LooksOne sx={{ color: COLORS.BLUE }} />
      </Typography>

      <Grid2 container spacing={"10px"}>
        <Grid2 xs={12} md={3}>
          <CustomAutocomplete
            options={industries1.data}
            value={industry}
            onChange={(e, newValue) => {
              setInputValues1((prev) => ({ ...prev, industry: newValue }));
              clearForm("industry", newValue);
            }}
            isLoading={industries1.isLoading}
            placeholder="صنعت"
          />
        </Grid2>
        <Grid2 xs={12} md={3}>
          <CustomAutocomplete
            options={commodityTypes1.data}
            value={commodityType}
            onChange={(e, newValue) => {
              setInputValues1((prev) => ({ ...prev, commodityType: newValue }));
              clearForm("commodityType", newValue);
            }}
            isLoading={commodityTypes1.isLoading}
            placeholder="نوع کالا"
          />
        </Grid2>
        <Grid2 xs={12} md={3}>
          <CustomAutocomplete
            options={commodities1.data}
            value={commodity}
            onChange={(e, newValue) => {
              setInputValues1((prev) => ({
                ...prev,
                commodity: newValue,
              }));
              clearForm("commodity", newValue);
            }}
            isLoading={commodities1.isLoading}
            placeholder="کالا (اختیاری)"
          />
        </Grid2>
        <Grid2 xs={12} md={3}>
          <CustomAutocomplete
            options={transitTypes1.data}
            value={transitType}
            onChange={(e, newValue) => {
              setInputValues1((prev) => ({
                ...prev,
                transitType: newValue,
              }));
              clearForm("transitType", newValue);
            }}
            isLoading={transitTypes1.isLoading}
            placeholder="نوع حمل و نقل (اختیاری)"
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default SpreadPriceForm1;
